import React, { useEffect, useRef, useState } from 'react';
import { Calendar, Clock, Info, CheckCircle, Upload, AlertTriangle } from 'lucide-react';
import './InscriptionConference.css'
import { useDispatch, useSelector } from 'react-redux';
import { getBookingByUrl, updateExternalUser } from './store/InscriptionConferenceThunks';
export default function InscriptionConference() {
  const [agreed, setAgreed] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const { conference, conferenceLink } = useSelector((state) => state.InscriptionConference);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: ''
  });
  const [fileObject, setFileObject] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isFinalStep, setIsFinalStep] = useState(false);


  const params = new URLSearchParams(window.location.search);
  const userEmail = params.get('email');
  // Dans votre composant :
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailFromUrl = params.get('email');

    if (emailFromUrl) {
      setFormData(prev => ({
        ...prev,
        email: decodeURIComponent(emailFromUrl)
      }));
    }
  }, []); // S'exécute une seule fois au montage
  const handleJoinConference = () => {
    if (conferenceLink) {
    
      localStorage.setItem('isguest', 'true');
      window.open(conferenceLink);
    }
  };
  const fileInputRef = useRef(null);

  const dispatch = useDispatch();

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileObject(file);
      const previewUrl = URL.createObjectURL(file);
      setSelectedImage(previewUrl);
    }
  };
  const handleRemoveImage = (e) => {
    e.stopPropagation();
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  };

  // Pour extraire uniquement l'heure : "14:52"
  const formatTimeOnly = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  };
  useEffect(() => {
    const currentFullUrl = window.location.href;

    if (currentFullUrl) {
      const baseUrl = currentFullUrl.split('?')[0];
      dispatch(getBookingByUrl({
        options: {
          query: {
            registration_link: baseUrl
          }
        }
      }));
    }
  }, [dispatch]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreed) {
      alert("Veuillez accepter les conditions RGPD.");
      return;
    }

    const data = new FormData();
    const userData = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      company: formData.company,
      display_name  : formData.firstName +" "+ formData.lastName ,
    };

    data.append('userData', JSON.stringify(userData));
    data.append('conference_id', conference?.id || '');
    if (fileObject) {
      data.append('file', fileObject);
    }

    try {
      await dispatch(updateExternalUser({ body: data }));


      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setShowSuccessPopup(true);

    } catch (error) {
      console.error("Erreur lors de l'inscription:", error);
    }
  };
  const handlePopupClose = () => {
    setShowSuccessPopup(false);
    setIsFinalStep(true);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      company: ''
    });
    setSelectedImage(null);
    setFileObject(null);
    setAgreed(false);
  };
  return (
    <>
      {!isFinalStep && (

        <div className="registration-container">
          <div className="form-card-inscri-conf">

            <div className="header-banner-inscri-conf">
              <img
                src={conference?.photo}
                alt="Séminaire"
              />
              <div className="date-badge-inscri-conf">
                <Calendar size={14} />
                {formatDate(conference?.date)}
              </div>
            </div>

            {/* Section Info (Encadré Vert) */}
            <div className="info-box-inscri-conf">
              <div className="info-title-inscri-conf">
                <Info size={18} />
                <span>A propos de l'évènement</span>
              </div>
              <p className="event-title-inscri-conf">{conference?.title}</p>
              <p className="event-details-inscri-conf">
                {conference?.description}
              </p>
            </div>

            <p className="form-instruction-inscri-conf">Inscrivez vous pour participer à la conférence</p>

            {/* Formulaire de saisie */}
            <form className="form-content-inscri-conf" onSubmit={handleSubmit}>
              <div className="form-grid-inscri-conf">
                <div className="form-group-inscri-conf">
                  <label>Prénom <span className="required-etoile">*</span></label>
                  <input
                    type="text"
                    required
                    value={formData.firstName}
                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                  />
                </div>
                <div className="form-group-inscri-conf">
                  <label>Nom <span className="required-etoile">*</span></label>
                  <input
                    type="text"
                    required
                    value={formData.lastName}
                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-grid-inscri-conf">
                <div className="form-group-inscri-conf">
                  <label>Email <span className="required-etoile">*</span></label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    disabled={!!userEmail} // désactivé seulement si email existe
                    style={{
                      backgroundColor: userEmail ? '#f0f0f0' : 'white',
                      cursor: userEmail ? 'not-allowed' : 'text'
                    }}
                  />
                </div>
                <div className="form-group-inscri-conf">
                  <label>Société (Optionnel)</label>
                  <input
                    type="text"
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group-inscri-conf">
                <label>Photo (Optionnel)</label>

                <div
                  className="upload-zone-inscri-conf"
                  onClick={handleUploadClick}
                  style={{ cursor: 'pointer', position: 'relative', overflow: 'hidden', minHeight: '9.375rem' }}
                >
                  {selectedImage ? (
                    <>
                      {/* Bouton Supprimer */}
                      <button
                        onClick={handleRemoveImage}
                        style={{
                          position: 'absolute',
                          top: '0.625rem',
                          right: '0.625rem',
                          backgroundColor: 'rgba(255, 0, 0, 0.7)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '1.5625rem',
                          height: '1.5625rem',
                          cursor: 'pointer',
                          zIndex: 10
                        }}
                      >
                        X
                      </button>

                      <img
                        src={selectedImage}
                        alt="Preview"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </>
                  ) : (
                    <>
                      <Upload size={24} />
                      <p>Cliquez pour ajouter une photo</p>
                    </>
                  )}

                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    accept="image/*"
                  />
                </div>

              </div>
              <div className="consent-box-inscri-conf" onClick={() => setAgreed(!agreed)}>
                <div className={`custom-radio-inscri-conf ${agreed ? 'active' : ''}`}>
                  <div className="radio-inner-circle-inscri-conf" />
                </div>
                <p className="rgpd-text">
                  J'accepte que mes données soient traitées dans le cadre de cette conférence conformément au RGPD. *
                </p>
              </div>


              <button type="submit" className="submit-btn-inscri-conf" disabled={!agreed}>
                S'inscrire
              </button>
            </form>

          </div>

          {showSuccessPopup && (
            <div className="modal-overlay-inscri-conf">
              <div className="success-modal-inscri-conf">
                <div className="modal-content-inscri-conf">
                  <div className="success-icon-wrapper-inscri-conf">
                    <CheckCircle size={48} color="#4CAF50" />
                  </div>
                  <h3>Inscription confirmée</h3>
                  <p>
                    Félicitations vous venez de vous inscrire avec succès à la conférence
                    <strong> {conference?.title}</strong>. Surveillez vos mails, vous allez recevoir un lien.
                  </p>
                  <button className="modal-btn-inscri-conf" onClick={handlePopupClose}>
                    J'ai compris
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

      )}
      {isFinalStep && (
        <div className="registration-container">
          <div className="form-card-inscri-conf">

            <div className="banner-wrapper">
              <img
                src={conference?.photo}
                alt="Séminaire"
                className="main-banner-inscri-conf"
              />
            </div>

            {/* 3. Contenu Texte */}
            <div className="content-body-inscri-conf">
              <h1 className="event-title-inscri-conf">{conference?.title}</h1>
              <p className="welcome-text-inscri-conf">
                Nous sommes ravis de vous inviter à notre conférence exclusive. Votre accès personnel a été généré avec succès.
              </p>

              {/* 4. Bloc Date et Heure (Gris) */}
              <div className="details-box-inscri-conf">
                <div className="detail-item-inscri-conf">
                  <Calendar size={18} className="icon-inscri" />
                  <div className="text-wrapper-inscri-conf">
                    <p className="detail-info-inscri-conf">Date</p>
                  </div>
                </div>
                <span className="detail-text-inscri-conf">{formatDateOnly(conference?.date)}</span>


                <div className="detail-item-inscri-conf">
                  <Clock size={18} className="icon-inscri" />
                  <div className="text-wrapper-inscri-conf">
                    <p className="detail-info-inscri-conf">Heure</p>
                  </div>
                </div>
                <span className="detail-text-inscri-conf">{formatTimeOnly(conference?.date)}</span>
              </div>



              {/* 5. Section Lien Unique (Encadré Vert) */}
              <div className="access-link-box-inscri-conf">
                <div className="link-header-inscri-conf">
                  <CheckCircle className="link-header-icon-inscri-conf" size={18} />
                  <span>Votre lien d'accès unique</span>
                </div>
                <p className="link-wor-inscri-conf">Ce lien est personnel et ne doit pas être partagé.</p>
                <div className="link-display-inscri-conf">
                  <a href={conferenceLink} target="_blank" rel="noopener noreferrer" className="clickable-link">
                    {conferenceLink}
                  </a>
                </div>
                <button
                  className="join-button-inscri-conf"
                  onClick={handleJoinConference}
                  disabled={!conferenceLink} // Désactive le bouton si le lien n'est pas encore chargé
                >
                  Rejoindre la conférence
                </button>        </div>

              <div className="important-note-container-inscri-conf">
                <div className="note-text-inscri-conf">
                  <AlertTriangle className="note-icon-inscri-conf" size={18} />
                  <p className="note-important-inscri-conf" >Important :</p>
                </div>
                <p> Nous vous recommandons de rejoindre la conférence 5 minutes avant le début pour vérifier votre connexion.</p>


              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}